module.exports = __webpack_public_path__ + "img/1582625812.6c986bf2.jpg";